export { Favicon } from './favicon';
